import Image from "next/image";
import Link from "next/link";

interface IDownloads {
  downloads?:
    | {
        name: string;
        icon: {
          sourceUrl: string;
        };
        file: {
          mediaItemUrl?: string;
        };
      }[]
    | null;
}

export const Downloads2 = ({ downloads }: IDownloads) => (
  <div className="my-4 flex flex-row flex-wrap">
    {downloads?.map((download) => {
      const link = download.file?.mediaItemUrl?.replace(
        "https://kns.you2.pl/wp-content",
        ""
      );
      return (
        <div className="mx-2 flex w-32 flex-col" key={download.name}>
          <div className="w-full">
            <Link href={`${link}`} rel="noopener" target="_blank">
              <Image
                alt={download.name}
                className="mx-auto"
                height={120}
                src={
                  download.icon?.sourceUrl
                    ? download.icon?.sourceUrl
                    : "/img/assets/download.png"
                }
                width={120}
              />
            </Link>
          </div>
          <div className="my-auto text-center text-sm hover:underline">
            <a href={`${link}`} rel="noopener" target="_blank">
              {download.name}
            </a>
          </div>
        </div>
      );
    })}
  </div>
);
